import React from 'react'
import axios from 'axios'

// Settings → Account → Password. Tailwind only (scoped under
// .project-notes-scope like every Tailwind component here; the settings page
// itself is still MUI, which this block deliberately does not extend).
export default function PasswordBlock() {
    const [hasPassword, setHasPassword] = React.useState(null)
    const [state, setState] = React.useState('idle') // idle | sending | sent | failed

    React.useEffect(() => {
        axios
            .get('/auth/password/status')
            .then(response =>
                setHasPassword(Boolean(response.data.hasPassword))
            )
            .catch(() => setHasPassword(null))
    }, [])

    async function requestLink() {
        setState('sending')
        try {
            await axios.post('/auth/password/link')
            setState('sent')
        } catch (error) {
            setState('failed')
        }
    }

    if (hasPassword === null) return null

    return (
        <div className="project-notes-scope">
            <section
                className="tw-my-4 tw-max-w-[800px] tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-card tw-p-4"
                data-testid="account-password-block"
            >
                <h3 className="tw-m-0 tw-mb-1 tw-text-base tw-font-semibold">
                    Password
                </h3>
                <p className="tw-m-0 tw-mb-3 tw-text-sm tw-text-muted-foreground">
                    {hasPassword
                        ? 'Change your password with a link we email you.'
                        : 'You sign in with email codes. Want a password too?'}
                </p>
                {state === 'sent' ? (
                    <p
                        className="tw-m-0 tw-text-sm tw-font-medium"
                        data-testid="account-password-sent"
                    >
                        Check your email — the link is on its way.
                    </p>
                ) : (
                    <button
                        type="button"
                        onClick={requestLink}
                        disabled={state === 'sending'}
                        data-testid="account-password-link"
                        className="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium hover:tw-bg-muted disabled:tw-opacity-50"
                    >
                        {state === 'sending' ? 'Sending…' : 'Email me a link'}
                    </button>
                )}
                {state === 'failed' ? (
                    <p
                        className="tw-m-0 tw-mt-2 tw-text-sm tw-text-destructive"
                        role="alert"
                    >
                        We could not send the link. Please try again.
                    </p>
                ) : null}
            </section>
        </div>
    )
}
